import { faToEn } from '@helper/convert-digit.js'

export default {
  filters: {
    roundOverall (value) {
      if (!value) { return '' }
      const round = Math.round(value * 10) / 10
      return round || 0
    },
    enToFaFilter (value) {
      if (!value) { return '' }
      return String(value).trim()
    },
    faToEnFilter (value) {
      if (!value) { return '' }
      return faToEn('' + value)
    },
    currency (value) {
      if (value !== 0 && !value) { return '' }
      if (Number(value) < 1000) { return value }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    shortType (value) {
      if (value % 1000 === 0) {
        return (value / 1000) + ' هزار'
      }
      return value
    }
  },
  methods: {
    enToFaMethod (value) {
      if (!value) { return '' }
      return value
    },
    faToEnMethod (value) {
      if (!value) { return '' }
      return faToEn('' + value)
    },
    currencyMethod (value) {
      if (!value) { return '' }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    currencyToNormalMethod (value) {
      if (!value) { return '' }
      return value.replace(/,/g, '')
    }
  }
}
